import { createSelector } from "@ngrx/store";
import { IStore } from "../store";

export const getTransactionsState = createSelector(
    (store: IStore) => store.transactions,
    store => store,
);
